import * as z from 'zod';

// MICA/ADR MI company codes (see MICA Delinquency (ADR) Record Specification, code table 8).
// FHA and VA codes from the source table are omitted: those loans report through TS 264, not the ADR.
export const MiCompanyCode = z.enum([
  '001', // Enact (formerly Genworth)
  '003', // MGIC
  '004', // PMI Mortgage Insurance Company
  '011', // Republic Mortgage Insurance Company
  '013', // United Guaranty Residential Insurance Company
  '019', // Triad Guaranty Insurance Company
  '033', // Radian Guaranty Inc.
  '038', // Arch Mortgage Insurance Company
  '039', // United Guaranty Mortgage Indemnity Co.
  '043', // Essent Guaranty
  '044', // National Mortgage Insurance Corporation
]);
export type MiCompanyCode = z.infer<typeof MiCompanyCode>;

export const MI_COMPANY_CODE_LABELS: Record<MiCompanyCode, string> = {
  '001': 'Enact',
  '003': 'MGIC',
  '004': 'PMI Mortgage Insurance',
  '011': 'Republic MI',
  '013': 'United Guaranty Residential',
  '019': 'Triad Guaranty',
  '033': 'Radian',
  '038': 'Arch MI',
  '039': 'United Guaranty Mortgage Indemnity',
  '043': 'Essent',
  '044': 'National MI',
};

export const formatMiCompanyCode = (code: MiCompanyCode): string => `${code} - ${MI_COMPANY_CODE_LABELS[code]}`;
